import { useContext, useEffect, useState } from "react";
import "./LoginPage.css";
import { GetNotificationStatus, SendOtp, VerifyOtp } from "../api/api";
import ErrorToast from "../components/toasts/ErrorToast";
import SuccessToast from "../components/toasts/SuccessToast";
import { useNavigate } from "react-router-dom";
import { Context } from "../context/Context";
import { set } from "react-hook-form";

const LoginPage = () => {
  const { page, setPage } = useContext(Context);
  const [loginState, setLoginState] = useState(0);
  const [user, setUser] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [otp, setOtp] = useState();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setPage({
      name: "پروفایل",
      slug: "profile",
    });
  }, []);

  const { setAuthUser, setToken, setNotificationStatus } = useContext(Context);

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const mobilePattern = /^(\+98|0)?9\d{9}$/;

  const handleInputUser = (val) => {
    if (val == "") {
      setUser(null);
      setErrorMessage("");
      return 0;
    }
    if (emailPattern.test(val) || mobilePattern.test(val)) {
      setUser(val);
      setErrorMessage("");
    } else {
      setUser(null);
      setErrorMessage("شماره همراه یا ایمیل وارد شده معتبر نمی باشد");
    }
  };

  const handleSendOtpCode = () => {
    if (!loginState) {
      if (emailPattern.test(user)) {
        setLoader(true);
        SendOtp({
          email: user,
        })
          .then(({ data }) => {
            if (!data.error) {
              setLoginState(1);
              return SuccessToast("", data.message);
            } else {
              return ErrorToast(data.message);
            }
          })
          .catch(({ response }) => {
            return ErrorToast(response.data.message);
          })
          .finally(() => setLoader(false));
      } else if (mobilePattern.test(user)) {
        setLoader(true);
        SendOtp({
          phone_number: user.replace(/^0/, ""),
        })
          .then(({ data }) => {
            if (!data.error) {
              setLoginState(1);
              return SuccessToast("", data.message);
            } else {
              return ErrorToast(data.message);
            }
          })
          .catch(({ response }) => {
            return ErrorToast(response.data.message);
          })
          .finally(() => setLoader(false));
      } else {
        ErrorToast(
          "خطا",
          "لطفا شماره همراه یا ایمیل خود را به درستی وارد کنید",
        );
      }
    } else if (loginState == 1) {
      setLoader(true);
      VerifyOtp({
        otp_code: otp,
      })
        .then(({ data }) => {
          if (!data.response.error) {
            setAuthUser(JSON.stringify(data.profile));
            setToken(data.token);
            localStorage.setItem("token", data.token);
            const mergedUser = { ...data.profile, ...data.user };
            localStorage.setItem("user", JSON.stringify(mergedUser));
            navigate("/");
            window.location.reload();
            SuccessToast(data.response.message);
            // GetNotificationStatus({
            //   api_key: data.profile.apikey,
            //   token: data.token,
            // })
            //   .then(({ data }) => {
            //     setNotificationStatus(data.status);
            //     localStorage.setItem("get_notification_status", data.status);
            //   })
            //   .catch((err) => {
            //     navigate("/");
            //     window.location.reload();
            //     SuccessToast(data.response.message);
            //   });
          } else {
            return ErrorToast(data.response.message);
          }
        })
        .catch((jqXHR) => {
          console.log(jqXHR);
          let errorMessage = "";
          switch (jqXHR.response.status) {
            case 400:
              for (var key in jqXHR.response.data) {
                if (jqXHR.response.data.hasOwnProperty(key)) {
                  return ErrorToast(jqXHR.response.data[key][0]);
                }
              }
              errorMessage = "An unexpected error occurred. Please try again.";
          }
        })
        .finally(() => setLoader(false));
    }
  };

  const handleGetNotification = () => {
    GetNotificationStatus().then((res) => {});
  };

  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner py-4">
          {/* Register */}
          <div className="card p-3" style={{borderRadius: '20px', background: "linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 255, 0.98) 100%)"}}>
            <div className="card-body">
              {/* Logo */}
              <div className="app-brand justify-content-center">
                <h4>سامانه مدیریت خانه هوشمند</h4>
              </div>
              {/* /Logo */}
              {/* <h4 className="mb-3 secondary-font">به رادکیت خوش آمدید!</h4>  */}
              {/* <p className="mb-4">
                لطفا وارد حساب خود شده و ماجراجویی را شروع کنید
              </p> */}
              {/* <div className="mb-3">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="user"
                    id="phoneNumber"
                    value="0"
                    checked={loginMode == 0 ? "checked" : ""}
                    onChange={() => setLoginMode(0)}
                  />
                  <label className="form-check-label" htmlFor="phoneNumber">
                    ورود با شماره همراه
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="user"
                    id="email"
                    value="1"
                    checked={loginMode == 1 ? "checked" : ""}
                    onChange={() => setLoginMode(1)}
                  />
                  <label className="form-check-label" htmlFor="email">
                    ورود با ایمیل
                  </label>
                </div>
              </div> */}
              <form id="formAuthentication" className="mb-3">
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    شماره همراه یا ایمیل
                  </label>
                  <input
                    type="text"
                    className="form-control text-start"
                    placeholder="شماره همراه یا ایمیل خود را وارد کنید"
                    autoFocus
                    dir="ltr"
                    onChange={(e) => handleInputUser(e.target.value)}
                    disabled={loginState ? "disabled" : ""}
                  />
                  <div className="text-danger" style={{ fontSize: "85%" }}>
                    {errorMessage}
                  </div>
                </div>
                <div
                  className={
                    loginState
                      ? "mb-3 form-password-toggle"
                      : "mb-3 form-password-toggle d-none"
                  }
                >
                  <div className="d-flex justify-content-between">
                    <label className="form-label" htmlFor="otp">
                      کد
                    </label>
                    {/* <a href="auth-forgot-password-basic.html">
                      <small>رمز عبور را فراموش کردید؟</small>
                    </a> */}
                  </div>
                  <div className="input-group input-group-merge">
                    <input
                      type="number"
                      id="otp"
                      className="form-control text-start"
                      aria-describedby="otp"
                      autoComplete="one-time-code"
                      dir="ltr"
                      placeholder="کد ارسال شده را وارد کنید"
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <button
                    className="btn btn-success-app d-grid w-100"
                    type="button"
                    onClick={handleSendOtpCode}
                  >
                    {loader ? (
                      <span
                        className="spinner-border"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <span>{loginState ? "ورود" : "ارسال کد"}</span>
                    )}
                  </button>
                </div>
              </form>

              {/* <p className="text-center">
                <span>کاربر جدید هستید؟</span>
                <a href="auth-register-basic.html">
                  <span>یک حساب بسازید</span>
                </a>
              </p> */}
            </div>
          </div>
          {/* /Register */}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
